import { SHORTCUT_DELIVERY_ZONE_FIELDS } from '@@partner:graphql/shortcuts'
import { DeliveryZone, GeoPoint, SlotPlanInfo } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'



export interface DeliveryZoneInfoInput {
  id?: GQL_ID
  shop_id?: GQL_ID
  name: string
  status: number
  zoneGeoDeliveryZone: GeoPoint[]
  minOrderCost: number

  zoneDeliveryCost: number
  zoneFirstDeliveryCost: number
  zoneSlotMaxWeight: number
  freeSlotDeliveryCostFrom: number

  zoneExpressDeliveryCost: number
  zoneExpressMaxWeight: number
  zoneHasExpressDeliveryEnabled: boolean
  zoneTsExpressDeliveryStart: number
  zoneTsExpressDeliveryFinish: number
  expressDeliveryMaxShippingTime: number
  freeExpressDeliveryCostFrom: number
  
  slotPlans: SlotPlanInfo[]
  deliveryProviders: string[]
  customer_order: number
}

export interface UpdateDeliveryZoneInfo {
  deliveryZoneInfo: DeliveryZone
}

export interface UpdateDeliveryZoneVariables {
  deliveryZoneInfo: DeliveryZoneInfoInput
}

export const GQL_MUTATION_UPDATE_DELIVERY_ZONE_INFO = gql`
  mutation updateDeliveryZoneInfo ($deliveryZoneInfo: DeliveryZoneInfoInput!) {
    deliveryZoneInfo: updateDeliveryZoneInfo(
      deliveryZoneInfo: $deliveryZoneInfo
    ) {
      ${SHORTCUT_DELIVERY_ZONE_FIELDS}
    }
  }
`

export const useSaveDeliveryZoneInfo = () => {
  return useMutation<UpdateDeliveryZoneInfo, UpdateDeliveryZoneVariables>(GQL_MUTATION_UPDATE_DELIVERY_ZONE_INFO)
}